import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { getAllTaskList } from '@blade-sxp/file-cluster/api/statistics/index';
let DeviceCascader = class DeviceCascader extends Vue {
    multiple;
    clearable;
    disabled;
    showTitle;
    collapseTags;
    // @Prop() options!: Array<any>;
    value;
    selectedValue = [];
    options = [];
    loading = false;
    onInputChange(val) {
        this.selectedValue = JSON.parse(JSON.stringify(this.value));
    }
    mounted() {
        this.getTasks();
    }
    remove(val) {
        this.$emit('remove-value', val);
    }
    handleChange(val) {
        this.$emit('update:value', val);
    }
    getTasks() {
        this.loading = true;
        // this.taskOptions = [];
        const reqParam = {
            taskTypes: ['REALTIME_CLUSTER'],
            // page: 1,
            // size: 100,
            // dateEnd: '',
            // dateStart: '',
            // pageOrderList: [{ orderField: 'create_time', orderType: 'DESC' }],
            // deviceId: '',
            // keyword: '',
            // zoneId: '',
            // taskStatus: '',
        };
        getAllTaskList(reqParam)
            .then((res) => {
            this.options = res
                ? res.map((el) => {
                    return {
                        label: el.name,
                        value: el.id,
                    };
                })
                : [];
        })
            .finally(() => {
            this.loading = false;
        });
    }
    isValidate() {
        if (this.multiple) {
            return this.value.length > 0;
        }
        else {
            return !!this.value;
        }
    }
};
__decorate([
    Prop({ type: Boolean, default: true })
], DeviceCascader.prototype, "multiple", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], DeviceCascader.prototype, "clearable", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], DeviceCascader.prototype, "disabled", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], DeviceCascader.prototype, "showTitle", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], DeviceCascader.prototype, "collapseTags", void 0);
__decorate([
    Prop()
], DeviceCascader.prototype, "value", void 0);
__decorate([
    Watch('value', { deep: true, immediate: true })
], DeviceCascader.prototype, "onInputChange", null);
DeviceCascader = __decorate([
    Component({
        name: 'TaskSelector',
        components: {},
        i18n: {
            messages: {
                en: {
                    placeholderTip: 'You can select at least one task for now',
                    taskTitle: 'Associated Clustering Task Name',
                    moreTip: 'A maximum of 100 devices can be selected simultaneously.',
                },
                zh: {
                    placeholderTip: '请至少选择一个关联聚类任务',
                    taskTitle: '关联聚档任务',
                    moreTip: '最多可同时选择100台设备。',
                },
            },
        },
    })
], DeviceCascader);
export default DeviceCascader;
